import { createStyles } from '@zn-material-ui'

export default () =>
  createStyles({
    dialogPaper: {
      overflow: 'hidden',
    },
    dialogContent: {
      padding: '0 50px  40px 50px',
      boxSizing: 'border-box',
    },
    dialogActions: {
      justifyContent: 'center',
      margin: 0,
      width: '100%',
      padding: '0 50px',
      boxSizing: 'border-box',
    },
    okBtn: {
      width: '100%',
      marginBottom: '62px !important',
    },
    sendText: {
      fontSize: 16,
      color: 'rgba(65,73,83,0.66)',
    },
    cellphoneNumber: {
      marginTop: 10,
      fontSize: 30,
      color: ' #363C46',
    },
  })
